'use client';
import React from 'react';

/**
 * Unified field wrapper — every inquiry field renders through this so the
 * required/optional labeling convention stays consistent (inverted: optional
 * fields are labeled rather than required ones starred).
 */
export default function Field({
  label,
  required,
  optional,
  hint,
  className = '',
  children,
}: {
  label: string;
  required?: boolean;
  optional?: boolean;
  hint?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div data-component-id="src/app/inquiry/components/Field.tsx:25:4" data-component-path="src/app/inquiry/components/Field.tsx" data-component-line="25" data-component-end-line="41" data-component-file="Field.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" className={className}>
      <label data-component-id="src/app/inquiry/components/Field.tsx:26:6" data-component-path="src/app/inquiry/components/Field.tsx" data-component-line="26" data-component-end-line="38" data-component-file="Field.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22flex%20items-center%20gap-1.5%20text-sm%20font-medium%20text-slate-700%20mb-1%22%7D" className="flex items-center gap-1.5 text-sm font-medium text-slate-700 mb-1">
        <span data-component-id="src/app/inquiry/components/Field.tsx:27:8" data-component-path="src/app/inquiry/components/Field.tsx" data-component-line="27" data-component-end-line="27" data-component-file="Field.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{label}</span>
        {required && (
          <span data-component-id="src/app/inquiry/components/Field.tsx:29:10" data-component-path="src/app/inquiry/components/Field.tsx" data-component-line="29" data-component-end-line="31" data-component-file="Field.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-red-500%22%2C%22textContent%22%3A%22*%22%7D" className="text-red-500" aria-hidden>
            *
          </span>
        )}
        {optional && (
          <span data-component-id="src/app/inquiry/components/Field.tsx:34:10" data-component-path="src/app/inquiry/components/Field.tsx" data-component-line="34" data-component-end-line="36" data-component-file="Field.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-%5B10px%5D%20uppercase%20tracking-wider%20font-semibold%20text-slate-400%20bg-slate-100%20rounded%20px-1.5%20py-0.5%22%2C%22textContent%22%3A%22optional%22%7D" className="text-[10px] uppercase tracking-wider font-semibold text-slate-400 bg-slate-100 rounded px-1.5 py-0.5">
            optional
          </span>
        )}
      </label>
      {children}
      {hint && <p data-component-id="src/app/inquiry/components/Field.tsx:40:15" data-component-path="src/app/inquiry/components/Field.tsx" data-component-line="40" data-component-end-line="40" data-component-file="Field.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-1%20text-xs%20text-slate-500%22%7D" className="mt-1 text-xs text-slate-500">{hint}</p>}
    </div>
  );
}
